import React from 'react';
import { Modal } from '../../components/ui';
import { isWeddingFunction, MAX_NAME } from '../../utils/helpers';

// Desktop add / edit dialog for a person the guest brings. Logic: useGuestHome.
export default function GuestFormDesktop({ vm }) {
  const { editing, form, formErr, saving, addedCount, pickerFunctions, closeForm, setField, toggleFunction, save } = vm;
  const submit = (e) => { e.preventDefault(); save({ addNext: !editing }); };

  return (
    <Modal title={editing ? 'Edit guest' : 'Add a guest'} onClose={closeForm}
      footer={(
        <>
          <button type="button" className="btn light" onClick={closeForm} disabled={saving}>{editing ? 'Cancel' : 'Done'}</button>
          {!editing && <button type="button" className="btn light" onClick={() => save()} disabled={saving}>Save &amp; close</button>}
          <button type="submit" form="guest-form" className="btn primary" disabled={saving}>
            {saving ? 'Saving…' : editing ? 'Save' : 'Save & add next'}
          </button>
        </>
      )}>
      <form id="guest-form" onSubmit={submit}>
        {!editing && addedCount > 0 && <div className="chip ok" style={{ marginBottom: 10 }}>{addedCount} added</div>}
        <div className="guest-form-grid">
          <label className="field">Surname
            <input value={form.Surname} maxLength={MAX_NAME} onChange={e => setField('Surname', e.target.value)} />
          </label>
          <label className="field">Name *
            <input value={form.GuestName} maxLength={MAX_NAME} autoFocus onChange={e => setField('GuestName', e.target.value)} />
          </label>
          <label className="field">Mobile (optional)
            <input value={form.MobileNumber} inputMode="numeric" placeholder="10 digits" onChange={e => setField('MobileNumber', e.target.value)} />
          </label>
        </div>
        <div className="field-label">Invite to *</div>
        <div className="guest-fn-checks">
          {pickerFunctions.map(f => (
            <label key={f.FunctionId}>
              <input type="checkbox" checked={form.FunctionIds.includes(String(f.FunctionId))}
                onChange={() => toggleFunction(f.FunctionId)} />
              {isWeddingFunction(f) ? '💍 ' : ''}{f.FunctionName}
            </label>
          ))}
        </div>
        {formErr && <div className="guest-form-err">⚠ {formErr}</div>}
      </form>
    </Modal>
  );
}
